import { Directive, HostListener, ElementRef, EventEmitter, Output, Input } from '@angular/core';
import { CartaoService } from '../../services/cartao/cartao.service';
import { contaStrings } from '../../../../environments/environment';

declare var $: any;

@Directive({
  selector: '[appBandeiraCartao]'
})
export class BandeiraCartaoDirective {
  @Input() public contaId = new EventEmitter();
  @Output() private bandeira = new EventEmitter();

  private stringCartao = '';

  private parent: any = null;
  private classesString = 'visa master elo amex diners discover aura jcb default';

  private bandeiras: any = [
    { name: 'Visa', cieloName: 'VISA', className: 'visa', regex: /^4\d{5}?/ },
    { name: 'Amex', cieloName: 'AMEX', className: 'amex', regex: /^(34|37)\d?/ },
    { name: 'Master',  cieloName: 'MASTERCARD', className: 'master', regex: /^5[1-5]\d?/ },
    // tslint:disable-next-line
    { name: 'Elo', cieloName: 'ELO', className: 'elo', regex: /^(40117[8-9]|431274|438935|451416|457393|45763[1-2]|506(699|7[0-6][0-9]|77[0-8])|509\d{3}|504175|627780|636297|636368|65003[1-3]|6500(3[5-9]|4[0-9]|5[0-1])|6504(0[5-9]|[1-3][0-9])|650(4[8-9][0-9]|5[0-2][0-9]|53[0-8])|6505(4[1-9]|[5-8][0-9]|9[0-8])|6507(0[0-9]|1[0-8])|65072[0-7]|6509(0[1-9]|1[0-9]|20)|6516(5[2-9]|[6-7][0-9])|6550([0-1][0-9]|2[1-9]|[3-4][0-9]|5[0-8]))\d?/ },
    { name: 'JCB', cieloName: 'JCB', className: 'jcb', regex: /^35\d?/ },
    { name: 'Aura', cieloName: 'AURA', className: 'aura', regex: /^50\d{2}?/ },
    { name: 'Diners', cieloName: 'DINERS', className: 'diners', regex: /^(301|305|36\d{3}?|38)\d?/ },
    { name: 'Discover', cieloName: 'DISCOVER', className: 'discover', regex: /^(6011|622|64|65)\d?/ },
    { name: 'Hipercard', cieloName: 'HIPERCARD', className: 'hipercard', regex: null },
  ];

  constructor(
    private elRef?: ElementRef,
    private cartaoService?: CartaoService
  ) {
    if (!this.elRef) {
      return;
    }

    $(this.elRef.nativeElement).wrap('<div style="margin-bottom: 5px;" class="form-group has-feedback text-left"></div>');
    $(this.elRef.nativeElement).parent().append('<figure class=\'bandeira-cartao default form-control-feedback\'></figure>');

    this.parent = $(this.elRef.nativeElement).parent();
  }

  @HostListener('keyup') onInputChange() {
    if (!this.elRef) {
      return;
    }

    if (this.elRef.nativeElement.value.length === 0) {
      $(this.parent).find('figure').removeClass(this.classesString).addClass('default');
      this.bandeira.emit({ name: '' });
      return;
    }

    if (this.isFirstDigitsChanged()) {
      this.obterBandeiraCielo();
    }
  }

  isFirstDigitsChanged() {
    const elValue = this.elRef.nativeElement.value.replace(/ /g, '');

    if (elValue.length >= 6) {
      if (this.stringCartao.indexOf(elValue.replace(/ /g, '').slice(0, 6)) === -1) {
        this.stringCartao = elValue.replace(/ /g, '').slice(0, 6);
        return true;
      }
    }
    this.stringCartao = elValue.replace(/ /g, '').slice(0, 6);
    return false;
  }

  obterBandeiraRegex() {
    let match = false;
    this.bandeiras.forEach((r, i) => {
      if (match) { return; }

      let elValue;
      elValue = this.elRef.nativeElement.value.replace(/ /g, '');

      if (r && r.regex && r.regex.test(elValue)) {
        $(this.parent).find('figure').removeClass(this.classesString).addClass(r.className);

        match = true;
        this.bandeira.emit({ name: r.name });

        return;
      }
    });

    if (!match) {
      this.bandeira.emit({ name: null });
      $(this.parent).find('figure').removeClass(this.classesString).addClass('default');
    }
  }

  obterBandeiraCielo() {
    let name = null;
    const numeroCartao = this.elRef.nativeElement.value.replace(/ /g, '');

    if (numeroCartao.length >= 6 && contaStrings.contaId) {
      this.cartaoService.obterBandeira(numeroCartao.slice(0, 6), contaStrings.contaId).subscribe((data: any) => {
        this.bandeiras.forEach((bandeira) => {
          if (data && data.Provider && data.Provider === bandeira.cieloName) {
            $(this.parent).find('figure').removeClass(this.classesString).addClass(bandeira.className);
            name = bandeira.name;
          } else if (data === null) {
            name = null;
            $(this.parent).find('figure').removeClass(this.classesString);
          }
        });

        name ? this.bandeira.emit({ name: name }) : this.obterBandeiraRegex();
      }, (err) => {
        this.obterBandeiraRegex();
        console.error(err);
      });
    } else if (numeroCartao.length < 6) {
      $(this.parent).find('figure').removeClass(this.classesString);
      this.bandeira.emit({ bandeira: null });
    }
  }
}
